/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'

class Header extends React.Component {

    render() {
        return (
            <div className="lecturer-invite-header">
                <div className="header-left">
                    <div className="header-left-tip">

                    </div>
                </div>
                <div className="header-right">
                    {this.props.targetName}
                </div>
            </div>
        )
    }
}

export default Header


// WEBPACK FOOTER //
// ./src/components/lecturerInvite/Header.js